import { Dispatch } from "@reduxjs/toolkit";
import h from "../helpers";

export const fetchSingleSegmentSelectionStatus =
    (flowId: number) =>
    (dispatch: Dispatch): void => {
        const countUrl = "/Flows/GetSingleSegmentSelectionStatus/" + flowId;
        fetch(countUrl, { credentials: "same-origin" })
            .then(h.checkStatus)
            .then(h.toJson)
            .then(data => {
                const response = data as unknown as {
                    ViolationSingleSelection: boolean;
                    ViolatingFlowItemIds: Array<number>;
                };
                dispatch({
                    type: "SET_SINGLE_SEGMENT_SELECTION_STATUS",
                    payload: { flowId, violatingFlowItemIds: response.ViolatingFlowItemIds },
                });
            })
            .catch(error => {
                h.error("Error getting activation schedules.", error);
            });
    };
